/**
 * Shows a lightweight toast message and returns a dismiss callback.
 * @param {string} message
 * @param {{ durationMs?: number, onClick?: () => void, centered?: boolean }} [options]
 * @returns {() => void}
 */
export function showToastMessage(message, options = {}) {
  const durationMs = options.durationMs || 12000;

  const toast = document.createElement("div");
  toast.textContent = message;
  if (options.onClick) {
    toast.style.cursor = "pointer";
    toast.dataset.clickableCursor = "true";
    toast.addEventListener("click", options.onClick);
  }
  toast.style.position = "fixed";
  toast.style.zIndex = "99999";

  const centerOffset = options.centered ? "translate(-50%, -50%) " : "";
  const initialTransform = `${centerOffset}translateY(-2px)`;
  const shownTransform = `${centerOffset}translateY(2px)`;
  const dismissedTransform = `${centerOffset}translateY(-4px)`;

  if (options.centered) {
    toast.style.top = "50%";
    toast.style.left = "50%";
  } else {
    toast.style.top = "20px";
    toast.style.right = "20px";
  }
  toast.style.transform = initialTransform;
  toast.style.maxWidth = "640px";
  toast.style.width = "min(640px, calc(100vw - 32px))";
  toast.style.padding = "12px 16px";
  toast.style.borderRadius = "12px";
  toast.style.border = "2px solid #3da7c2";
  toast.style.background = "#112a53";
  toast.style.color = "#aae3ff";
  toast.style.fontFamily = '"Motley Forces", sans-serif';
  toast.style.fontSize = "22px";
  toast.style.lineHeight = "1.3";
  toast.style.textAlign = "center";
  toast.style.letterSpacing = "0.2px";
  toast.style.boxShadow = "0 10px 24px rgba(0, 0, 0, 0.28)";
  toast.style.opacity = "0";
  toast.style.transition = "opacity 180ms ease, transform 180ms ease";

  document.body.appendChild(toast);
  requestAnimationFrame(() => {
    toast.style.opacity = "1";
    toast.style.transform = shownTransform;
  });

  let removeTimeoutId = null;
  let autoDismissTimeoutId = null;

  const dismiss = () => {
    if (autoDismissTimeoutId) {
      clearTimeout(autoDismissTimeoutId);
      autoDismissTimeoutId = null;
    }
    if (removeTimeoutId) {
      clearTimeout(removeTimeoutId);
      removeTimeoutId = null;
    }

    toast.style.opacity = "0";
    toast.style.transform = dismissedTransform;
    removeTimeoutId = setTimeout(() => {
      if (toast.parentNode) {
        toast.parentNode.removeChild(toast);
      }
    }, 180);
  };

  autoDismissTimeoutId = setTimeout(dismiss, durationMs);

  return dismiss;
}
